exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-8be3543e] legend{color:#fff!important;background:var(--sidebar-color)!important}[data-v-8be3543e] .answer{width:45%!important}[data-v-8be3543e] .answer label>*{cursor:pointer}[data-v-8be3543e] .answer:hover{background:hsla(0,0%,100%,.5)!important}", ""]);

// exports
